import React, { memo } from "react";

import { WidgetDeviceType, WidgetRenderLocation } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { IgMessageBox } from "@src/domains/WidgetLibrary/MessageBox/IgMessageBox";
import { UserInterfaceWidgetPreview as Preview } from "@src/features/personalizations/components/offerModifications/widgets/UserInterfaceWidgetPreview";
import { useDispatch, useSelectorFactory } from "@src/store";
import { setDialog } from "@src/store/slices/global";
import { getUserInterfaceMessageBox } from "@src/store/slices/widgets/selectors";

import { WidgetMoreMenu } from "./WidgetMoreMenu";

interface MessageBoxPreviewProps {
  variationId: string;
  hideLabel?: boolean;
  renderLocation?: WidgetRenderLocation;
}

export const MessageBoxPreview = ({
  variationId,
  hideLabel,
  renderLocation,
}: MessageBoxPreviewProps) => {
  const dispatch = useDispatch();
  const widget = useSelectorFactory(getUserInterfaceMessageBox, variationId);

  if (!widget) return null;

  const handleEdit = () => {
    dispatch(
      setDialog({
        dialog: "offers",
        open: true,
        props: { targetPage: "messageBox" },
      })
    );
  };

  const handleDelete = () => {
    dispatch(
      setDialog({
        dialog: "deleteComponent",
        open: true,
        props: {
          componentType: "messageBox",
          variationId,
        },
      })
    );
  };

  return (
    <Preview renderLocation={renderLocation}>
      {!hideLabel && (
        <Preview.Label
          label={renderLocation === "settings" ? "Preview" : "Message Box"}
          menu={
            renderLocation === "settings" ? null : (
              <WidgetMoreMenu onEdit={handleEdit} onDelete={handleDelete} />
            )
          }
        />
      )}
      <Preview.Widget device={"desktop"} renderLocation={renderLocation}>
        <IgMessageBox device={"desktop"} widget={widget} />
      </Preview.Widget>
    </Preview>
  );
};
